//console.log("brand landing extra js...");

const toTimestamp = (strDate) => {
  const dt = Date.parse(strDate);
  return dt / 1000;
};

let ny_date = new Date().toLocaleString("en-US", {timeZone: "America/New_York"});
// console.log("ny_date: " + ny_date);
// console.log("ny_date: " + toTimestamp(ny_date));
// console.log("test date:" + toTimestamp("5/11/2023, 3:29 PM"));

let test_date = $('.hp-module-a').data('test');
// console.log("test_date from attribute: " + toTimestamp(test_date));

$('.bl-module-a .block-container').each(function() {
	let expireString = $(this).data('expire');
	if (expireString) {
		// console.log("expireString: " + expireString);
		let expireDate = toTimestamp(expireString);
		let nowDateString = new Date().toLocaleString("en-US", {timeZone: "America/New_York"});
		let nowDate = toTimestamp(nowDateString);
		// console.log("nowDate: " + nowDate);
		// console.log("expireDate: " + expireDate);
		if (nowDate > expireDate) {
			// console.log("removing hp module block container");
			$(this).remove();
		} else {
			// console.log("don't remove yet");
		}
	}
});
